/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationCatalogEntity } from './IntegrationCatalogEntity';
import {
    IntegrationCatalogEntityFromJSON,
    IntegrationCatalogEntityFromJSONTyped,
    IntegrationCatalogEntityToJSON,
    IntegrationCatalogEntityToJSONTyped,
} from './IntegrationCatalogEntity';

/**
 * 
 * @export
 * @interface IntegrationVersionEntity
 */
export interface IntegrationVersionEntity {
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    id?: string;
    /**
     * 
     * @type {IntegrationCatalogEntity}
     * @memberof IntegrationVersionEntity
     */
    integration?: IntegrationCatalogEntity;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    releaseNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    changelog?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    breakingChanges?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    packageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    packageHash?: string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationVersionEntity
     */
    packageSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    sourceCode?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationVersionEntity
     */
    packageInfo?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    dependencies?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    minPlatformVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    maxPlatformVersion?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationVersionEntity
     */
    isLatest?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationVersionEntity
     */
    isDeprecated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    deprecationReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationVersionEntity
     */
    releasedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationVersionEntity
     */
    releasedBy?: string;
}

/**
 * Check if a given object implements the IntegrationVersionEntity interface.
 */
export function instanceOfIntegrationVersionEntity(value: object): value is IntegrationVersionEntity {
    return true;
}

export function IntegrationVersionEntityFromJSON(json: any): IntegrationVersionEntity {
    return IntegrationVersionEntityFromJSONTyped(json, false);
}

export function IntegrationVersionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationVersionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'integration': json['integration'] == null ? undefined : IntegrationCatalogEntityFromJSON(json['integration']),
        'version': json['version'] == null ? undefined : json['version'],
        'releaseNotes': json['releaseNotes'] == null ? undefined : json['releaseNotes'],
        'changelog': json['changelog'] == null ? undefined : json['changelog'],
        'breakingChanges': json['breakingChanges'] == null ? undefined : json['breakingChanges'],
        'packageUrl': json['packageUrl'] == null ? undefined : json['packageUrl'],
        'packageHash': json['packageHash'] == null ? undefined : json['packageHash'],
        'packageSizeBytes': json['packageSizeBytes'] == null ? undefined : json['packageSizeBytes'],
        'sourceCode': json['sourceCode'] == null ? undefined : json['sourceCode'],
        'packageInfo': json['packageInfo'] == null ? undefined : json['packageInfo'],
        'dependencies': json['dependencies'] == null ? undefined : json['dependencies'],
        'minPlatformVersion': json['minPlatformVersion'] == null ? undefined : json['minPlatformVersion'],
        'maxPlatformVersion': json['maxPlatformVersion'] == null ? undefined : json['maxPlatformVersion'],
        'isLatest': json['isLatest'] == null ? undefined : json['isLatest'],
        'isDeprecated': json['isDeprecated'] == null ? undefined : json['isDeprecated'],
        'deprecationReason': json['deprecationReason'] == null ? undefined : json['deprecationReason'],
        'releasedAt': json['releasedAt'] == null ? undefined : (new Date(json['releasedAt'])),
        'releasedBy': json['releasedBy'] == null ? undefined : json['releasedBy'],
    };
}

export function IntegrationVersionEntityToJSON(json: any): IntegrationVersionEntity {
    return IntegrationVersionEntityToJSONTyped(json, false);
}

export function IntegrationVersionEntityToJSONTyped(value?: IntegrationVersionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'integration': IntegrationCatalogEntityToJSON(value['integration']),
        'version': value['version'],
        'releaseNotes': value['releaseNotes'],
        'changelog': value['changelog'],
        'breakingChanges': value['breakingChanges'],
        'packageUrl': value['packageUrl'],
        'packageHash': value['packageHash'],
        'packageSizeBytes': value['packageSizeBytes'],
        'sourceCode': value['sourceCode'],
        'packageInfo': value['packageInfo'],
        'dependencies': value['dependencies'],
        'minPlatformVersion': value['minPlatformVersion'],
        'maxPlatformVersion': value['maxPlatformVersion'],
        'isLatest': value['isLatest'],
        'isDeprecated': value['isDeprecated'],
        'deprecationReason': value['deprecationReason'],
        'releasedAt': value['releasedAt'] == null ? undefined : ((value['releasedAt']).toISOString()),
        'releasedBy': value['releasedBy'],
    };
}

